export const CLIENT_PROFILE_ROWS = {
	clientID: 'Client ID:',
	resourceIDs: 'Resource IDs:',
	clientSecret: 'Client Secret:',
	scope: 'Scope:',
	authorizedGrantTypes: 'Authorized Grant Types:',
	webServerRedirectUri: 'Web Server Redirect Uri:',
	authorities: 'Authorities:',
	accessTokenValidity: 'Access Token Validity:',
	refreshTokenValidity: 'Refresh Token Validity:',
	additionalInformation: 'Additional Information:',
	autoApprove: 'Auto Approve:',
};
